import { render, staticRenderFns } from "./EPGMappings.vue?vue&type=template&id=376d49e4&"
import script from "./EPGMappings.vue?vue&type=script&lang=js&"
export * from "./EPGMappings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports